/** Relationships card (secondary column): who at Ember knows this entity, ranked.
 * DERIVED from interaction co-occurrence (frequency + recency) — labeled as such,
 * never presented as curated. Bar = fixed linear scale against the strongest row. */
import styles from './crm.module.css';
import { useCrmConnections, type CrmEntityKind } from '../../hooks/useCrm';
import { fmtRecency } from './crmFormat';

interface Props {
  kind: CrmEntityKind;
  id: number;
}

export function CrmRelationships({ kind, id }: Props) {
  const conns = useCrmConnections(kind, id);
  const rows = conns.data?.rows ?? [];
  const max = Math.max(...rows.map((r) => r.total), 1);
  return (
    <div className={styles.card}>
      <div className={styles.cardTitle}>
        Relationships
        <span className={styles.cardTitleNote}>interaction-based</span>
      </div>
      {conns.isLoading && <div className={styles.loading}>Loading…</div>}
      {conns.error != null && <div className={styles.error}>Failed to load relationships.</div>}
      {!conns.isLoading && !conns.error && rows.length === 0 && (
        <div className={styles.empty}>No Ember interactions recorded.</div>
      )}
      {rows.length > 0 && (
        <table className={styles.sideTable}>
          <tbody>
            {rows.map((r) => (
              <tr key={r.person_id}>
                <td>
                  <div className={styles.rowName}>{r.name || r.email}</div>
                  <div className={styles.strengthBar}>
                    <span
                      className={styles.strengthFill}
                      style={{ width: `${Math.max(4, Math.round((r.total / max) * 100))}%` }}
                    />
                  </div>
                </td>
                <td className={styles.rowNum} title={`${r.emails} emails · ${r.meetings} meetings`}>
                  {r.total} · {fmtRecency(r.last_at)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div className={styles.hint}>
        Strength = interaction frequency + recency (derived, not curated). N · last-contact.
      </div>
    </div>
  );
}
